import { AuthContext } from "@@components";
import LoginIcon from "@mui/icons-material/Login";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import { Box, Button, Paper, Typography } from "@mui/material";
import React, { useContext } from "react";

const HomeView: React.FC = () => {
  const auth = useContext(AuthContext);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "70vh",
        px: 2,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 6,
          maxWidth: 500,
          textAlign: "center",
          background: (theme) => `linear-gradient(135deg, ${theme.palette.background.paper} 0%, ${theme.palette.primary.dark}15 100%)`,
        }}
      >
        <RocketLaunchIcon sx={{ fontSize: 80, color: "primary.main", mb: 3 }} />
        <Typography variant="h3" gutterBottom sx={{ fontWeight: 600, mb: 2 }}>
          Welcome to Randol
        </Typography>
        <Typography variant="h6" color="text.secondary" sx={{ mb: 4 }}>
          Application Runtime Platform
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          Sign in to access your applications and start building amazing experiences.
        </Typography>
        <Button variant="contained" size="large" startIcon={<LoginIcon />} onClick={() => auth.authService.signIn()} sx={{ mt: 2, px: 4 }}>
          Sign In
        </Button>
      </Paper>
    </Box>
  );
};

export default HomeView;
